import { defineStore } from 'pinia'
import type {UserDataOutput} from "~/api/generated";
import {extractInitials} from "~/utils/CapitalizeLetters";

const STORE_NAME = 'session';
interface sessionData {
  loggedIn: boolean;
  user: UserDataOutput | undefined;
  userInitials: string | undefined;
  popupBanner: boolean;
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  intentUrl: string | any | undefined;
}

const initialState = {
  loggedIn: false,
  user: undefined,
  userInitials: undefined,
  popupBanner: true,
  intentUrl: undefined
} as sessionData;

export const useSessionStore = defineStore(STORE_NAME, {
  state: () => ({
    session: initialState as sessionData,
  }),
  persist: {
    storage: persistedState.localStorage,
  },
  actions: {
    setIntentUrl(intentUrl: string|any) {
      this.$state.session.intentUrl = intentUrl
    },
    setUser(user: UserDataOutput) {
      this.$state.session.user = user;
      this.$state.session.userInitials = extractInitials(`${user.name} ${user.surname}`)
    },
    setLoggedIn(status: boolean){
      this.$state.session.loggedIn = status;
    },
    setPopupBanner(showBanner: boolean) {
      this.$state.session.popupBanner = showBanner
    },
    _reset() {
      this.$reset();
    }
  }
})
